// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"337":"f8dd17f5","571":"13abf662"}[chunkId] + ".chunk.css";
};